import { isMobile } from './mobile';

export function goto(url) {
  if (isMobile()) {
    window.location.href = url;
  } else {
    window.open(url, '_blank');
  }
}
